import { useQuery } from "@tanstack/react-query";

import { TIME_INTERVALS } from "shared/lib/constants/time";

import { useApiClient } from "@/context/api-client";
import { DocsQueryKeys } from "@/api/routes/docs/queries/keys";

export const useQueryFetchGitbookDocs = (spaceId: string, path: string) => {
  const api = useApiClient();

  const gitbookDocsApi = useQuery({
    enabled: false, // fetched manually by the component that uses this hook
    queryKey: DocsQueryKeys.gitbookDocs(spaceId, path),
    queryFn: () => api.fetchGitbookDocs({ spaceId, path }),
    staleTime: TIME_INTERVALS.FIVE_MINUTES,
    select: (data) => data.data,
  });

  return gitbookDocsApi;
};
